export default __webpack_public_path__ + "assets/images/a6e1ca3937aabf48b73189494d1e7556.png";